import { Box, Grid, Typography } from '@mui/material';

import { FHInputField } from '../../../../../../components/base';
import { FInput } from '../../../../../../components/baseV2';
import {
  LEGACY_OTHER_FIELD_LABEL_SX,
  LEGACY_OTHER_FIELD_WRAPPER_SX,
} from '../styles';

import type { OtherFieldProps } from '../types';

export default function OtherField({
  dataTestId,
  disabled,
  label,
  legacyLabel,
  legacyPlaceholder,
  onChange,
  placeholder,
  useNewUi,
  value,
}: OtherFieldProps) {
  if (useNewUi) {
    return (
      <FInput
        data-testid={dataTestId}
        label={label}
        value={value}
        onChange={(event) => onChange('other', event.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        fullWidth
      />
    );
  }

  return (
    <Grid xs={12}>
      <Box sx={LEGACY_OTHER_FIELD_WRAPPER_SX}>
        <Typography sx={LEGACY_OTHER_FIELD_LABEL_SX}>{legacyLabel}</Typography>
        <FHInputField
          data-testid={dataTestId}
          value={value}
          onChange={(event) => onChange('other', event.target.value)}
          disabled={disabled}
          placeholder={legacyPlaceholder}
          inputHeight={40}
        />
      </Box>
    </Grid>
  );
}
